import { IMapZoneInfoDTO } from 'api/swagger/ApiClient';
import { computedFrom } from 'aurelia-framework';
import { Country, Site } from "model/business-keywords";
import { QueryFilter } from "model/essential-types";
import { UsersLocationsQueryFilter } from "model/users-locations";
import { UserContact } from '../business-types';

export class UsersLocationsFilter implements QueryFilter, UsersLocationsQueryFilter {
  constructor(public text: string = null, public user: UserContact = null, public country: Country = null, public mapZone: IMapZoneInfoDTO = null, public insideMapZone: boolean = true, public site: Site = null, public selectedLocation: L.LatLng = null, public distanceFromSiteInMeters: number = 100, public locationCurrentnessStatus: number = null) { }

  canClear(hint?: any) {
    return this.text != null || this.user != null || this.country != null || this.mapZone != null || this.locationCurrentnessStatus != null || this.site != null || this.selectedLocation != null;
  }

  clear(hint?: any) {
    this.text = null;
    this.user = null;
    this.country = null;
    this.mapZone = null;
    this.site = null;
    this.selectedLocation = null;
    this.distanceFromSiteInMeters = 1000;
    this.locationCurrentnessStatus = null;
  }

  @computedFrom('text', 'user', 'country', 'mapZone', 'locationCurrentnessStatus', 'site', 'selectedLocation')
  get canSearch() {
    return (this.text != null && this.text.length >= 3) || this.user != null || this.country != null || this.mapZone != null || this.locationCurrentnessStatus != null || this.site != null || this.selectedLocation != null;
  }
}
